var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.875rem",
    height: "0.5625rem",
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70706 6.08597L11.707 0L13.207 1.5L5.70706 8.91397L6.19888e-05 3.20697L1.41406 1.79297L5.70706 6.08597Z",
    fill: "#80C68F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmarkIcon);
export default __webpack_public_path__ + "static/media/greenCheckmarkIcon.cdc3becdf49ae94ea890202b4018584d.svg";
export { ForwardRef as ReactComponent };